import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-close",
  "use": "icon-icon-close-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-icon-close\"><path class=\"cls-1\" d=\"M655.7,510.6l276.7-276.7c39.1-39.1,39.1-102.5,0-141.6h0c-39.1-39.1-102.5-39.1-141.6,0l-276.7,276.7L239.7,94.7c-39.1-39.1-102.5-39.1-141.6,0h0c-39.1,39.1-39.1,102.5,0,141.6l274.4,274.4L90.3,792.7c-39.1,39.1-39.1,102.5,0,141.6h0c39.1,39.1,102.5,39.1,141.6,0l282.1-282.1,274.4,274.4c39.1,39.1,102.5,39.1,141.6,0h0c39.1-39.1,39.1-102.5,0-141.6l-274.4-274.4Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol